import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-un-authorized',
    templateUrl: './un-authorized.component.html',
    styleUrl: './un-authorized.component.scss'
})
export class UnAuthorizedComponent {
  @Input()
  set errorStatusCode(statusCode: number) {
    this.messageToDisplay = statusCode === 401 ? this.UnAuthorizedMessage : this.ApiFailureMessage;
  };
  UnAuthorizedMessage = {
    header: "Insufficient Access",
    body: "You are not authorized to use this platform. Please raise a request to get access."
  }
  ApiFailureMessage = {
    header: "API Failure",
    body: "Unable to get the necessary details from API. Please try after some time."
  }
  messageToDisplay = this.UnAuthorizedMessage;
}
